import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form/immutable';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import { Map } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Loading } from '../../../../../loadbar/Loading';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import {
  clearEditVolcanoEvent as clearEditVolcanoEventAc,
  createVolcanoEvent as createVolcanoEventAc,
  getVolcanoEvent as getVolcanoEventAc,
  updateVolcanoEvent as updateVolcanoEventAc,
  getVolcanoLocation as getVolcanoLocationAc,
  getEarthquake as getEarthquakeAc,
  getReferences as getReferencesAc,
  searchReferences as searchReferencesAc,
  searchTsunamis as searchTsunamisAc,
  getTsunami as getTsunamiAc,
  searchEarthquakes as searchEarthquakesAc,
  getAgents as getAgentsAc,
  sortTsunamis as sortTsunamisAc,
  sortEarthquakes as sortEarthquakesAc,
  sortReferences as sortReferencesAc,
  sortVolcanoLocations as sortVolcanoLocationsAc,
  openEditConfirmation as openEditConfirmationAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
  toggleEarthquakeColumns as toggleEarthquakeColumnsAc,
  toggleTsunamiColumns as toggleTsunamiColumnsAc,
  toggleReferenceColumns as toggleReferenceColumnsAc,
  toggleVolLocColumns as toggleVolLocColumnsAC,
} from '../../../../../../redux/volcanoes/event/edit/volcanoEventEditActions';
import { volcanoEventEditModel, createInitialForm, formToJson } from './volcanoEventEditModel';
import { VolcanoLocationSearchControl } from './VolcanoLocationSearchControl';
import { AssociatedEarthquakeControl } from '../../../../../form/AssociatedEarthquakeControl';
import { AssociatedReferenceControl } from '../../../../../form/AssociatedReferenceControl';
import { AssociatedTsunamiControl } from '../../../../../form/AssociatedTsunamiControl';
import { LabeledCheckbox } from '../../../../../form/LabeledCheckbox';
import { CommentsEditor } from '../../../../../form/CommentsEditor';
import { EditForm } from '../../../../../form/EditForm';

const model = volcanoEventEditModel.get('name');
const initialValues = volcanoEventEditModel.get('initialValues');

class EditVolcanoEventPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.resetForm = this.resetForm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      initialized: false,
      isAdd: false,
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Volcano Event Edit';
    const {
      match: { params: { id } },
      getVolcanoEvent, getVolcanoLocation, getEarthquake, getReferences, getTsunami, getAgents, history,
    } = this.props;
    const isAdd = !id;
    const state = {
      isAdd,
    };
    if (id) {
      getVolcanoEvent({ id, history });
      getVolcanoLocation({ id, history });
      getEarthquake({ id, history });
      getReferences({ id, history });
      getTsunami({ id, history });
    }
    getAgents({ history });
    this.setState(state);
  }

  componentDidUpdate() {
    const { initialized } = this.state;
    if (!initialized) {
      const {
        fetched, initializeForm, volcanoEvent,
      } = this.props;
      if (fetched) {
        const form = createInitialForm(volcanoEvent);
        initializeForm(form);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ initialized: true });
      }
    }
  }

  componentWillUnmount() {
    const {
      resetForm, initializeForm, setPristine, clearEditVolcanoEvent,
    } = this.props;
    clearEditVolcanoEvent();
    initializeForm(initialValues);
    resetForm();
    setPristine();
  }

  resetForm() {
    const {
      resetForm, setPristine, change, volcanoEvent,
    } = this.props;
    resetForm();
    // There seems to be a bug in react-redux-form. This needs to be called to set the original references.
    // change('.referenceIds', createInitialForm(volcanoEvent).get('referenceIds'));
    change('', createInitialForm(volcanoEvent));
    setPristine();
  }

  cancel() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { isAdd, initialized } = this.state;
    const {
      pristine, updating, volcanoLocation, earthquake, references,
      searchReferences, referenceSearching, referenceSearchResults, tsunami,
      searchTsunamis, tsunamiSearching, tsunamiSearchResults,
      earthquakeSearching, earthquakeSearchResults, searchEarthquakes, agents,
      peopleDescriptors, damageDescriptors, housesDescriptors,
      volLocSort,
      sortVolcanoLocations,
      tsuSort,
      sortTsunamis,
      eqSort,
      sortEarthquakes,
      refSort,
      sortReferences,
      match: { params: { id } },
      history,
      createVolcanoEvent,
      updateVolcanoEvent,
      formData,
      editConfirmationOpen,
      cancelEditConfirmation,
      openEditConfirmation,
      volcanoEvent,
      toggleEarthquakeColumns,
      eqVisibleColumns,
      toggleTsunamiColumns,
      tsuVisibleColumns,
      toggleReferenceColumns,
      refVisibleColumns,
      toggleVolLocColumns,
      volLocVisibleColumns,
    } = this.props;
    if (!initialized) {
      return (<Loading />);
    }

    const peopleDescriptorsJs = peopleDescriptors.toJS();
    const damageDescriptorsJs = damageDescriptors.toJS();
    const housesDescriptorsJs = housesDescriptors.toJS();

    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">{isAdd ? 'Add Volcano Event' : `Edit Volcano Event: ${id}`}</CardTitle>

            <EditForm
              model={model}
              hazardName="Volcano Event"
              saving={updating}
              create={createVolcanoEvent}
              update={updateVolcanoEvent}
              isAdd={isAdd}
              id={id || '-1'}
              formData={formData}
              editConfirmationOpen={editConfirmationOpen}
              handleOpen={form => openEditConfirmation({ formData: formToJson(form) })}
              handleCancel={cancelEditConfirmation}
              original={volcanoEvent}
            >

              <VolcanoLocationSearchControl
                model={model}
                volcanoLocation={volcanoLocation}
                sort={volLocSort}
                history={history}
                sortData={sortVolcanoLocations}
                visibleColumns={volLocVisibleColumns}
                toggleColumns={toggleVolLocColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Dates</CardTitle>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-4']} model=".year" label="Year" readOnly={updating} helpModalId="volEventYear" />
                    <LabeledText formGroupClassName={['col-sm-4']} model=".month" label="Month" readOnly={updating} helpModalId="month" />
                    <LabeledText formGroupClassName={['col-sm-4']} model=".day" label="Day" readOnly={updating} helpModalId="day" />
                  </div>
                  <div className="form-row">
                    {/* TODO date hint / validation */}
                    <LabeledText formGroupClassName={['col-sm-6']} model=".startDate" label="Start Date" readOnly={updating} helpModalId="volEventStartDate" />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".endDate" label="End Date" readOnly={updating} helpModalId="volEventEndDate" />
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Measurements</CardTitle>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-12']} model=".vei" label="VEI" readOnly={updating} helpModalId="volEventVei" />
                  </div>
                  <div className="form-row">
                    <LabeledSelect childOptions={agents.toJS()} formGroupClassName={['col-4']} parentModel={model} fieldId="agent" label="Agent" readOnly={updating} multiselect filterable prependId helpModalId="volEventAgent" />
                    <LabeledCheckbox formGroupClassName={['col-4']} model=".eruption" label="Eruption" helpModalId="volEventEruption" />
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Effects</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".deaths" label="Deaths" readOnly={updating} helpModalId="volEventDeaths" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="deathsAmountOrder" label="Deaths Description" readOnly={updating} sorted={false} prependId helpModalId="volEventDeathsDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".missing" label="Missing" readOnly={updating} helpModalId="volEventMissing" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="missingAmountOrder" label="Missing Description" readOnly={updating} sorted={false} prependId helpModalId="volEventMissingDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".injuries" label="Injuries" readOnly={updating} helpModalId="volEventInjuries" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="injuriesAmountOrder" label="Injuries Description" readOnly={updating} sorted={false} prependId helpModalId="volEventInjuriesDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".damageMillionsDollars" label="Damage ($Mil)" readOnly={updating} helpModalId="volEventDamage" />
                    <LabeledSelect childOptions={damageDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="damageAmountOrder" label="Damage Description" readOnly={updating} sorted={false} prependId helpModalId="volEventDamageDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDestroyed" label="Houses Destroyed" readOnly={updating} helpModalId="volEventHousesDestroyed" />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDestroyedAmountOrder" label="Houses Destroyed Description" readOnly={updating} sorted={false} prependId helpModalId="volEventHousesDestroyedDescription" />
                  </div>

                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Total Effects (Earthquake and Tsunami, Volcano, etc.)</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".deathsTotal" label="Total Deaths" readOnly={updating} helpModalId="volEventTotalDeaths" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="deathsAmountOrderTotal" label="Total Deaths Description" readOnly={updating} sorted={false} prependId helpModalId="volEventTotalDeathsDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".missingTotal" label="Total Missing" readOnly={updating} helpModalId="volEventTotalMissing" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="missingAmountOrderTotal" label="Total Missing Description" readOnly={updating} sorted={false} prependId helpModalId="volEventTotalMissingDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".injuriesTotal" label="Total Injuries" readOnly={updating} helpModalId="volEventTotalInjuries" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="injuriesAmountOrderTotal" label="Total Injuries Description" readOnly={updating} sorted={false} prependId helpModalId="volEventTotalInjuriesDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".damageMillionsDollarsTotal" label="Total Damage ($Mil)" readOnly={updating} helpModalId="volEventTotalDamage" />
                    <LabeledSelect childOptions={damageDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="damageAmountOrderTotal" label="Total Damage Description" readOnly={updating} sorted={false} prependId helpModalId="volEventTotalDamageDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDestroyedTotal" label="Total Houses Destroyed" readOnly={updating} helpModalId="volEventTotalHousesDestroyed" />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDestroyedAmountOrderTotal" label="Total Houses Destroyed Description" readOnly={updating} sorted={false} prependId helpModalId="volEventTotalHousesDestroyedDescription" />
                  </div>

                </CardBody>
              </Card>

              <AssociatedEarthquakeControl
                model={model}
                earthquake={earthquake}
                earthquakeSearching={earthquakeSearching}
                earthquakeSearchResults={earthquakeSearchResults}
                searchEarthquakes={config => searchEarthquakes({ ...config, history })}
                sort={eqSort}
                visibleColumns={eqVisibleColumns}
                sortData={sortEarthquakes}
                toggleColumns={toggleEarthquakeColumns}
              />

              <AssociatedTsunamiControl
                model={model}
                tsunami={tsunami}
                searchTsunamis={config => searchTsunamis({ ...config, history })}
                tsunamiSearching={tsunamiSearching}
                tsunamiSearchResults={tsunamiSearchResults}
                sort={tsuSort}
                sortData={sortTsunamis}
                visibleColumns={tsuVisibleColumns}
                toggleColumns={toggleTsunamiColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Comments</CardTitle>
                  <CommentsEditor model={model} readOnly={updating} />
                </CardBody>
              </Card>

              <AssociatedReferenceControl
                model={model}
                initialReferences={references}
                searchReferences={config => searchReferences({ ...config, history })}
                referenceSearching={referenceSearching}
                referenceSearchResults={referenceSearchResults}
                sort={refSort}
                sortData={sortReferences}
                visibleColumns={refVisibleColumns}
                toggleColumns={toggleReferenceColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Visibility</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".significant" label="Significant" />
                    <LabeledCheckbox inline model=".publish" label="Publish" />
                  </div>
                </CardBody>
              </Card>

              <div>
                <Button disabled={updating || pristine} type="submit" color="primary" className="ml-5">{isAdd ? 'Create' : 'Update'}</Button>
                <Button disabled={updating || pristine} color="secondary" className="ml-2" onClick={this.resetForm}>Reset</Button>
                <Button disabled={updating} color="secondary" className="ml-2" onClick={this.cancel}>Cancel</Button>
              </div>
            </EditForm>

          </CardBody>
        </Card>

      </div>
    );
  }
}

EditVolcanoEventPageUnwrapped.propTypes = {
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }).isRequired,
  fetched: PropTypes.bool.isRequired,
  updating: PropTypes.bool.isRequired,
  getVolcanoEvent: PropTypes.func.isRequired,
  getVolcanoLocation: PropTypes.func.isRequired,
  getReferences: PropTypes.func.isRequired,
  searchReferences: PropTypes.func.isRequired,
  volcanoEvent: ImmutablePropTypes.map.isRequired,
  volcanoLocation: ImmutablePropTypes.map.isRequired,
  references: ImmutablePropTypes.list.isRequired,
  resetForm: PropTypes.func.isRequired,
  setPristine: PropTypes.func.isRequired,
  initializeForm: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  updateVolcanoEvent: PropTypes.func.isRequired,
  createVolcanoEvent: PropTypes.func.isRequired,
  clearEditVolcanoEvent: PropTypes.func.isRequired,
  history: PropTypes.shape({ goBack: PropTypes.func }).isRequired,
  change: PropTypes.func.isRequired,
  getEarthquake: PropTypes.func.isRequired,
  getTsunami: PropTypes.func.isRequired,
  earthquake: ImmutablePropTypes.map.isRequired,
  tsunami: ImmutablePropTypes.map.isRequired,
  referenceSearching: PropTypes.bool.isRequired,
  referenceSearchResults: ImmutablePropTypes.list.isRequired,
  tsunamiSearching: PropTypes.bool.isRequired,
  tsunamiSearchResults: ImmutablePropTypes.list.isRequired,
  searchTsunamis: PropTypes.func.isRequired,
  earthquakeSearching: PropTypes.bool.isRequired,
  earthquakeSearchResults: ImmutablePropTypes.list.isRequired,
  searchEarthquakes: PropTypes.func.isRequired,
  agents: ImmutablePropTypes.list.isRequired,
  getAgents: PropTypes.func.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  housesDescriptors: ImmutablePropTypes.list.isRequired,
  volLocSort: ImmutablePropTypes.list.isRequired,
  sortVolcanoLocations: PropTypes.func.isRequired,
  tsuSort: ImmutablePropTypes.list.isRequired,
  sortTsunamis: PropTypes.func.isRequired,
  eqSort: ImmutablePropTypes.list.isRequired,
  sortEarthquakes: PropTypes.func.isRequired,
  refSort: ImmutablePropTypes.list.isRequired,
  sortReferences: PropTypes.func.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,

  toggleEarthquakeColumns: PropTypes.func.isRequired,
  eqVisibleColumns: ImmutablePropTypes.list.isRequired,

  toggleTsunamiColumns: PropTypes.func.isRequired,
  tsuVisibleColumns: ImmutablePropTypes.list.isRequired,

  toggleReferenceColumns: PropTypes.func.isRequired,
  refVisibleColumns: ImmutablePropTypes.list.isRequired,

  toggleVolLocColumns: PropTypes.func.isRequired,
  volLocVisibleColumns: ImmutablePropTypes.list.isRequired,
};

const defaultMap = Map();

const mapStateToProps = (state, props) => {
  const { match: { params: { id } } } = props;
  const isAdd = !id;

  const fetchedCheck = [
    state.getIn(['volcanoEventEditPage', 'fetchedAgents']),
  ];
  if (!isAdd) {
    fetchedCheck.push(
      state.getIn(['volcanoEventEditPage', 'fetched']),
      state.getIn(['volcanoEventEditPage', 'fetchedVolcanoLocation']),
      state.getIn(['volcanoEventEditPage', 'fetchedEarthquake']),
      state.getIn(['volcanoEventEditPage', 'fetchedTsunami']),
      state.getIn(['volcanoEventEditPage', 'fetchedReferences']),
    );
  }

  const earthquakes = state.getIn(['volcanoEventEditPage', 'earthquake']);
  const tsunamis = state.getIn(['volcanoEventEditPage', 'tsunami']);

  const fetched = fetchedCheck.every(v => v);

  return {
    fetched,
    volcanoEvent: state.getIn(['volcanoEventEditPage', 'volcanoEvent']),
    volcanoLocation: state.getIn(['volcanoEventEditPage', 'volcanoLocation']),
    earthquake: earthquakes.size ? earthquakes.get(0) : defaultMap,
    tsunami: tsunamis.size ? tsunamis.get(0) : defaultMap,
    references: state.getIn(['volcanoEventEditPage', 'references']),
    pristine: state.get('forms')[model].$form.pristine,
    updating: state.getIn(['volcanoEventEditPage', 'updating']),
    referenceSearching: state.getIn(['volcanoEventEditPage', 'referenceSearching']),
    referenceSearchResults: state.getIn(['volcanoEventEditPage', 'referenceSearchResults']),
    tsunamiSearching: state.getIn(['volcanoEventEditPage', 'tsunamiSearching']),
    tsunamiSearchResults: state.getIn(['volcanoEventEditPage', 'tsunamiSearchResults']),
    earthquakeSearching: state.getIn(['volcanoEventEditPage', 'earthquakeSearching']),
    earthquakeSearchResults: state.getIn(['volcanoEventEditPage', 'earthquakeSearchResults']),
    agents: state.getIn(['volcanoEventEditPage', 'agents']),
    housesDescriptors: state.getIn(['effectDescriptors', 'houses']),
    damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
    peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
    tsuSort: state.getIn(['volcanoEventEditPage', 'tsuSort']),
    eqSort: state.getIn(['volcanoEventEditPage', 'eqSort']),
    refSort: state.getIn(['volcanoEventEditPage', 'refSort']),
    volLocSort: state.getIn(['volcanoEventEditPage', 'volLocSort']),
    formData: state.getIn(['volcanoEventEditPage', 'formData']),
    editConfirmationOpen: state.getIn(['volcanoEventEditPage', 'editConfirmationOpen']),
    eqVisibleColumns: state.getIn(['volcanoEventEditPage', 'eqVisibleColumns']),
    tsuVisibleColumns: state.getIn(['volcanoEventEditPage', 'tsuVisibleColumns']),
    refVisibleColumns: state.getIn(['volcanoEventEditPage', 'refVisibleColumns']),
    volLocVisibleColumns: state.getIn(['volcanoEventEditPage', 'volLocVisibleColumns']),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getVolcanoEvent: getVolcanoEventAc,
  clearEditVolcanoEvent: clearEditVolcanoEventAc,
  updateVolcanoEvent: updateVolcanoEventAc,
  createVolcanoEvent: createVolcanoEventAc,
  getVolcanoLocation: getVolcanoLocationAc,
  getEarthquake: getEarthquakeAc,
  getTsunami: getTsunamiAc,
  getReferences: getReferencesAc,
  searchReferences: searchReferencesAc,
  searchTsunamis: searchTsunamisAc,
  searchEarthquakes: searchEarthquakesAc,
  getAgents: getAgentsAc,
  resetForm: () => actions.reset(model),
  change: (field, value) => actions.change(`${model}${field}`, value),
  initializeForm: volcano => actions.load(model, volcano),
  setPristine: () => actions.setPristine(model),
  sortTsunamis: sortTsunamisAc,
  sortEarthquakes: sortEarthquakesAc,
  sortReferences: sortReferencesAc,
  sortVolcanoLocations: sortVolcanoLocationsAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
  toggleEarthquakeColumns: toggleEarthquakeColumnsAc,
  toggleTsunamiColumns: toggleTsunamiColumnsAc,
  toggleReferenceColumns: toggleReferenceColumnsAc,
  toggleVolLocColumns: toggleVolLocColumnsAC,
}, dispatch);

export const VolcanoEventEditPage = connect(mapStateToProps, mapDispatchToProps)(EditVolcanoEventPageUnwrapped);
